import { Box, Grid, TablePagination, TextField } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { TeamTile } from "../../../../components/analysis/tiles";
import { useGlobal } from "../../../../context/GlobalProvider";
import { EventTile } from "../../../../components/analysis/tiles";

export default function RecentsSearch() {
  const { eventList, teamList, recentPages } = useGlobal();

  return (
    <Grid container spacing={2}>
      {recentPages.map((page) => {
        const parts = page.split("-");
        if (parts[0] === "Team") {
          const team = teamList.find(
            (t) => t.team_number.toString() === parts[1]
          );
          return team ? <TeamTile key={team.team_number} team={team} /> : null;
        } else if (parts[0] === "Event") {
          const event = eventList.find((e) => e.eventCode === parts[1]);
          return event ? (
            <EventTile key={event.eventCode} event={event} />
          ) : null;
        } else if (parts[0] === "TeamEvent") {
          const team = teamList.find(
            (t) => t.team_number.toString() === parts[1]
          );
          return team ? (
            <TeamTile key={team.team_number} team={team} event={parts[2]} />
          ) : null;
        }
        return null;
      })}
    </Grid>
  );
}
